import { StyleSheet } from 'react-native';
import type { StylesMap } from 'types';

const styles: StylesMap = {
    languageSelect: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: 3
    }
};

export default StyleSheet.create(styles);
